// ./src/pages/public/ResetPasswordPage/ResetPasswordPage.tsx
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Alert } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { AuthLayout } from "../../../components/layouts/AuthLayout";
import { ResetPasswordForm } from "../../../components/features/Authentication/ResetPasswordForm";
import { PageProps } from "@sdflc/react-router-pages";

// Props that @sdflc/react-router-pages passes to page components
export interface ResetPasswordPageProps extends PageProps {}

export const ResetPasswordPage: React.FC<ResetPasswordPageProps> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const requestId = searchParams.get("token");

  const handleResetSuccess = () => {
    navigate("/account/signin");
  };

  // If no requestId is present, show error
  if (!requestId) {
    return (
      <AuthLayout title="Reset Password" subtitle="Set your new password">
        <Alert color="red" icon={<IconInfoCircle size={16} />}>
          Invalid or missing reset link. Please request a new password reset
          from the sign in page.
        </Alert>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset Password" subtitle="Set your new password">
      <ResetPasswordForm
        requestId={requestId}
        onResetSuccess={handleResetSuccess}
      />
    </AuthLayout>
  );
};
